import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { LANDING } from '../../routes/paths';
import * as notify from '../layout/Notifications/actions';

const withAuth = (WrappedComponent) => {
  class AuthorizationWrapper extends React.Component {
    componentWillMount() {
      const { authorized, notification } = this.props;

      if (!authorized) {
        const { history, onErrorPath } = this.props;
        history.push(onErrorPath);
        notification('Permission denied!', notify.ERROR);
      }
    }

    render() {
      return <WrappedComponent />;
    }
  }

  AuthorizationWrapper.propTypes = {
    authorized: PropTypes.bool.isRequired,
    onErrorPath: PropTypes.string.isRequired,
    notification: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired
  };

  return AuthorizationWrapper;
};

const mapStateToProps = (selector, onErrorPath) => state => ({
  authorized: selector(state),
  onErrorPath
});

const mapDispatchToProps = () => ({
  notification: notify.add
});

export default (userSelector, onErrorPath = LANDING) => (wrappedComponent) => (
  withRouter(connect(
    mapStateToProps(userSelector, onErrorPath),
    mapDispatchToProps()
  )(withAuth(wrappedComponent)))
);
